export const content = {
  en: {
    nav: {
      about: "About",
      timeline: "Projects",
      media: "Media",
      articles: "Articles",
      contact: "Contact us",
      language: "عربي",
    },
    brand: {
      name: "Abdulaziz Albaker",
      mark: "A. Albaker",
    },
    hero: {
      overline: "Welcome to the Journalist's Website",
      name: "Abdulaziz",
      nameAccent: "Albaker",
      title: "Presenter & Sports Journalist",
      lede: "Since 2003… a journalist, trainer and sports consultant — working on developing and shaping sports television content.",
      ctaPrimary: "Get in touch",
      ctaSecondary: "Projects",
      scroll: "Scroll",
      metaLine: "Based in KSA · Available worldwide",
    },
    about: {
      overline: "About",
      heading: "My journey in media.",
      paragraphs: [
        "I hold an enduring passion for developing sports media, always striving to craft purposeful content that blends deep knowledge with compelling delivery — and to build a strong, lasting relationship with the audience.",
        "Since 2003 my passion for media was ignited — beginning with university studies in media. Across those years I've taken on analytical studios and talk shows, crossing 20,000+ hours of live broadcast. That work has translated naturally into television training and media consulting, and into studies that shape personal and on-air content.",
        "Al-Hayat London newspaper added the journalistic experience every broadcaster needs, reinforcing the value of press craft and its effect on content creation.",
        "I believe stumbles and mistakes are the most honest teachers — never be ashamed of yours.",
      ],
      stats: [
        { value: "20,000+", label: "Live Broadcast Hours" },
        { value: "2003", label: "Started in Media" },
        { value: "20+", label: "Years of Experience" },
        { value: "7+", label: "Media Platforms" },
      ],
    },
    timeline: {
      overline: "Projects",
      heading: "Projects I've contributed to.",
      sub: "A selected timeline of projects, roles and commissions.",
      items: [
        { year: "2013", tag: "Trainer", title: "Sports Presenting Trainer", org: "Al Jazeera Training & Development Center" },
        { year: "2014", tag: "Direction", title: "Led the Analytical Studios", org: "MBC PRO Sports Channels" },
        { year: "2017", tag: "Founding", title: "Founded the Public Relations Dept.", org: "Tawahud (Autism) Center" },
        { year: "2018", tag: "Campaign", title: "Managed the World Cup Content Campaign", org: "with Mihyar" },
        { year: "2019", tag: "Strategy", title: "Delivered a Development Study", org: "for Sports Channels" },
      ],
    },
    media: {
      overline: "Featured Networks & Publishers",
      heading: "Stations along the journey.",
      outlets: ["MBC PRO", "Al-Hayat London", "Al Jazeera Training Center", "Mihyar", "Tawahud Center", "KSA Sports"],
    },
    articles: {
      overline: "Selected Articles & Documentaries",
      heading: "Events · Occasions · Videos.",
      readMore: "Read more",
      items: [
        {
          date: "30 · May · 2025",
          category: "Documentary",
          title: "The Road to the Most Precious of Cups",
          excerpt: "On 30 May 2025, the sports documentary 'Qadisiyah's Road' was aired — a story of ambition, discipline and the long climb to a continental crown.",
        },
        {
          date: "22 · May · 2025",
          category: "Feature",
          title: "Pride of Al-Ahsa · The Miracle",
          excerpt: "A closer reading of how a region rewrote its own sporting memory — the people, the pitch, the quiet miracle.",
        },
        {
          date: "11 · Dec · 2024",
          category: "Editorial",
          title: "Hello, World — from Saudi Arabia",
          excerpt: "Notes from the ground on what global-scale hosting means for Saudi sports and the storytellers who cover it.",
        },
        {
          date: "06 · May · 2021",
          category: "Essay",
          title: "Tarahum · A Human Responsibility",
          excerpt: "Why media professionals carry a duty that goes beyond the microphone — a meditation on empathy in public voice.",
        },
      ],
    },
    contact: {
      overline: "Contact",
      heading: "Your message is always welcome.",
      sub: "Welcome.",
      fields: {
        name: "Your name",
        email: "Your email",
        subject: "Subject",
        message: "Your message",
        captcha: "Quick check (anti-spam)",
      },
      send: "Send message",
      sending: "Sending…",
      success: "Message received. I'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      captchaError: "Wrong answer, please try again.",
      direct: "Or write directly",
    },
    footer: {
      tagline: "",
      rights: "All rights reserved.",
      builtFor: "",
    },
  },

  ar: {
    nav: {
      about: "نبذة",
      timeline: "المشاريع",
      media: "الجهات الإعلامية",
      articles: "المقالات",
      contact: "تواصل معنا",
      language: "English",
    },
    brand: {
      name: "عبدالعزيز البكر",
      mark: "ع. البكر",
    },
    hero: {
      overline: "حياك الله في موقع الإعلامي",
      name: "عبدالعزيز",
      nameAccent: "البكر",
      title: "مُقدِّم و إعلامي رياضي",
      lede: "منذ عام 2003… إعلامي ومدرب ومستشار رياضي، أعمل في تطوير وصياغة المحتوى التلفزيوني الرياضي.",
      ctaPrimary: "تواصل معي",
      ctaSecondary: "المشاريع",
      scroll: "انزل",
      metaLine: "من المملكة العربية السعودية · متاح للتعاون حول العالم",
    },
    about: {
      overline: "نبذة",
      heading: "رحلتي في الإعلام",
      paragraphs: [
        "أملكُ شغفًا دائمًا للمساهمة في التطوير الإعلامي الرياضي، وأسعى دائمًا إلى تقديم محتوى هادف يجمع بين المعرفة العميقة والطرح المشوق، مع الحرص على ربط علاقة قويةٍ ومتينةٍ مع المتابعين.",
        "منذ عام 2003 بدأ الشغف للعمل الإعلامي، انطلق ذلك من دراستي الجامعية في قسم الإعلام. خلال هذه السنوات خضتُ تجارب متنوعة ومثيرة في تقديم الاستوديوهات التحليلية والبرامج الحوارية، حيث تجاوزت 20 ألف ساعة بثٍّ مباشر. منحتني هذه التجارب القدرة على نقلها سواء في مجال التدريب التلفزيوني أو في تقديم الاستشارات الإعلامية، كذلك ساهمت هذه الخبرات في تقديم الدراسات لتطوير المحتوى الشخصي للأفراد والتلفزيوني.",
        "كما أضافت لي صحيفة الحياة اللندنية الخبرة الصحفية التي يحتاجها العمل الإعلامي، وعزَّزت لي من خلالها مفهوم العمل الإعلامي وقيمة العمل الصحفي وتأثيره في صناعة المحتوى.",
        "أرى أنَّ العثرات والأخطاء هي الدروس التي استفدتُ منها… فلا تخجل من أخطائك.",
      ],
      stats: [
        { value: "+20,000", label: "ساعة بث مباشر" },
        { value: "2003", label: "بداية المشوار" },
        { value: "+20", label: "عامًا من الخبرة" },
        { value: "+7", label: "منصّات إعلامية" },
      ],
    },
    timeline: {
      overline: "المشاريع",
      heading: "مشاريع ساهمت بها",
      sub: "مُختارات من المشاريع والأدوار والتكاليف المهنية.",
      items: [
        { year: "2013", tag: "تدريب", title: "مدرِّب تقديم رياضي", org: "مركز الجزيرة للتدريب والتطوير" },
        { year: "2014", tag: "إدارة", title: "إدارة الاستوديوهات التحليلية", org: "قنوات MBC PRO الرياضية" },
        { year: "2017", tag: "تأسيس", title: "تأسيس قسم العلاقات العامة", org: "مركز توحُّد" },
        { year: "2018", tag: "حملة", title: "إدارة حملة محتوى كأس العالم", org: "بالشراكة مع مهيار" },
        { year: "2019", tag: "استراتيجية", title: "تقديم دراسة تطوير", org: "للقنوات الرياضية" },
      ],
    },
    media: {
      overline: "أبرز الجهات الإعلامية",
      heading: "محطات في مسيرتي",
      outlets: ["MBC PRO", "صحيفة الحياة اللندنية", "مركز الجزيرة للتدريب", "مهيار", "مركز توحُّد", "القنوات الرياضية السعودية"],
    },
    articles: {
      overline: "مختارات من المقالات والوثائقيات",
      heading: "أحداث - مناسبات - فيديوهات",
      readMore: "اقرأ المزيد",
      items: [
        {
          date: "٣٠ · مايو · ٢٠٢٥",
          category: "وثائقي",
          title: "وثائقي… الطريق إلى أغلى الكؤوس",
          excerpt: "في يوم ٣٠ مايو ٢٠٢٥ عُرض الوثائقي الرياضي «طريق القادسية» — قصةُ طموحٍ وانضباطٍ ورحلةٍ طويلة نحو تاجٍ قاري.",
        },
        {
          date: "٢٢ · مايو · ٢٠٢٥",
          category: "قراءة",
          title: "فخر الأحساء… المعجزة",
          excerpt: "قراءةٌ أعمق لكيف أعاد إقليمٌ كتابة ذاكرته الرياضية — الناسُ والملعبُ والمعجزةُ الهادئة.",
        },
        {
          date: "١١ · ديسمبر · ٢٠٢٤",
          category: "افتتاحية",
          title: "أهلًا بالعالم… في السعودية",
          excerpt: "ملاحظاتٌ من قلب الحدث حول ما تعنيه استضافة الأحداث الكبرى للإعلام الرياضي السعودي وللرواة الذين يُغطّونها.",
        },
        {
          date: "٠٦ · مايو · ٢٠٢١",
          category: "مقال",
          title: "تراحم… مسؤولية إنسانية",
          excerpt: "لماذا يحمل المشتغلون بالإعلام مسؤوليةً تتجاوز الميكروفون — تأمّلٌ في قيمة التراحم في الصوت العام.",
        },
      ],
    },
    contact: {
      overline: "تواصل",
      heading: "تواصلك محل ترحيب دائماً",
      sub: "أهلا بك",
      fields: {
        name: "اسمك",
        email: "بريدك الإلكتروني",
        subject: "الموضوع",
        message: "رسالتك",
        captcha: "تأكيد (حماية من الرسائل المزعجة)",
      },
      send: "إرسال الرسالة",
      sending: "جاري الإرسال…",
      success: "تم استلام رسالتك. سأتواصل معك قريبًا.",
      error: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
      captchaError: "الإجابة غير صحيحة، حاول مرة أخرى.",
      direct: "أو راسلني مباشرةً",
    },
    footer: {
      tagline: "",
      rights: "جميع الحقوق محفوظة.",
      builtFor: "",
    },
  },
};

export const images = {
  hero: "https://albakertv-website-production.up.railway.app/api/media/69fe01f5fc7620bb760f4f5a",
  about: "https://images.unsplash.com/photo-1763128734412-e1aa7d71d006?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxicm9hZGNhc3QlMjBzdHVkaW8lMjBkYXJrfGVufDB8fHx8MTc3Njk4ODU5OXww&ixlib=rb-4.1.0&q=85",
  articles: [
    "https://images.unsplash.com/photo-1620567253244-6f340f675bca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjB0cm9waHklMjBkYXJrfGVufDB8fHx8MTc3Njk4ODYxMnww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1663900108404-a05e8bf82cda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxyaXlhZGglMjBza3lsaW5lJTIwbmlnaHR8ZW58MHx8fHwxNzc2OTg4NjEyfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1676746610993-fa0c050d1f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjBzdGFkaXVtJTIwbmlnaHR8ZW58MHx8fHwxNzc2OTgwMzc1fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1738734021916-13e949136b25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxicm9hZGNhc3QlMjBzdHVkaW8lMjBkYXJrfGVufDB8fHx8MTc3Njk4ODU5OXww&ixlib=rb-4.1.0&q=85",
  ],
};
